import { IMembershipPlanPriceModel } from '../../../../models/MembershipPlanPriceModel';

export enum SRMembersListFilters {
  Search = 'search',
  Plan = 'plan',
  MemberType = 'memberType',
  RenewStatus = 'renewStatus',
  SubscriptionId = 'subscriptionId',
  OversubscribedOnly = 'oversubscribedOnly',
}

export type SRMembersFiltersProps = {
  availableFilters: SRMembersListFilters[];
  standardPricing?: IMembershipPlanPriceModel[];
};
